import { APP_HEADER_CONSTANT } from '../constants/AppHeaderConstant';

export const initAppHeader = () => {
    return {
        type: APP_HEADER_CONSTANT.INIT_HEADER
    }
}

export const showOutlookMenu = anchor => {
    return {
        type: APP_HEADER_CONSTANT.SHOW_OUTLOOK_MENU,
        anchor
    }
}

export const hideOutlookMenu = () => {
    return {
        type: APP_HEADER_CONSTANT.HIDE_OUTLOOK_MENU
    }
}